import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { getContent } from '@/services/api';
import Placeholder from '../../components/Placeholder';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import { TABLET_P } from '../../constants';
import {
  Wrapper,
  PageTitle,
  Section,
  SectionTitle,
  SectionItems,
  SectionItem,
  ItemTitle,
  Subitems,
  Subcategories,
  Subcategory,
  Subitem,
} from './Sitemap.style';

const placeholderArray = [
  { key: 1, children: [{ key: 1 }, { key: 2 }] },
  {
    key: 2,
    children: [7, 6, 5, 4, 3, 2, 1].map(key => ({
      key,
      children: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }, { key: 5 }, { key: 6 }, { key: 7 }].slice(0, key),
    })),
  },
  { key: 3 },
];

const contentTypeToUrl = {
  productRangeHairCare: 'range/hair-care',
  productRangeHairColor: 'range/hair-color',
  productRangeMakeUp: 'range/make-up',
  productRangeMens: 'range/mens',
  productRangePerm: 'range/perm',
  productRangeSkinBodyCare: 'range/skin-body-care',
  productRangeStyling: 'range/styling',
};

class Sitemap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // SEO 対策に必要なメタデータ
      siteOptionsMetaData: {},
    };
  }

  componentWillMount() {
    const { locale } = this.props;

    if (locale) {
      // SEO 対策に必要なメタデータを取得する
      getContent({ contentType: 'siteOptionsMetaData', locale, slug: 'sitemap' }).then(siteOptionsMetaData =>
        this.setState({ siteOptionsMetaData })
      );
    }
  }

  render() {
    const { copy, locale, sitemap } = this.props;
    const { siteOptionsMetaData } = this.state;

    return (
      <React.Fragment>
        {_.get(siteOptionsMetaData, 'metaData') && (
          <Helmet
            title={_.get(siteOptionsMetaData.metaData, 'title')}
            link={[
              makeCanonicalTagObj(locale, '/sitemap'),
              ...makeHreflangTagArr(siteOptionsMetaData.metaData.region, '/sitemap'),
            ]}
            meta={[
              {
                name: 'description',
                content: _.get(siteOptionsMetaData.metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(siteOptionsMetaData.metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(siteOptionsMetaData.metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(siteOptionsMetaData.metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(siteOptionsMetaData.metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(siteOptionsMetaData.metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(siteOptionsMetaData.metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(siteOptionsMetaData.metaData, 'siteName'),
              // },
            ]}
          />
        )}
        <Wrapper>
          {copy ? <PageTitle>{copy.sitemap}</PageTitle> : <Placeholder h="25px" w="100px" />}

          {sitemap
            ? sitemap.map(section => (
              <Section key={section.label}>
                {section.url ? (
                  <SectionTitle underline>
                    <Link to={`/${locale}${section.url}`} href={`/${locale}${section.url}`}>
                      {section.label}
                    </Link>
                  </SectionTitle>
                ) : (
                  <SectionTitle>{section.label}</SectionTitle>
                )}

                {section.children && (
                  <SectionItems>
                    {section.children.map(item => (
                      <SectionItem key={item.label}>
                        <ItemTitle>{item.label}</ItemTitle>

                        {item.children && (
                          <Subitems>
                            {item.children.map(
                              subitem =>
                                subitem.contentType === 'siteOptionsProductSubcategory' ? (
                                  <Subcategories key={subitem.label}>
                                    <Subcategory>{subitem.label}</Subcategory>
                                    {subitem.children.map(range => (
                                      <Subitem key={range.name}>
                                        <Link
                                          to={`/${locale}/${contentTypeToUrl[range.contentType]}/${range.slug}`}
                                          href={`/${locale}/${contentTypeToUrl[range.contentType]}/${range.slug}`}
                                        >
                                          {range.name}
                                        </Link>
                                      </Subitem>
                                    ))}
                                  </Subcategories>
                                ) : (
                                  <Subitem key={subitem.name}>{subitem.name}</Subitem>
                                )
                            )}
                          </Subitems>
                        )}
                      </SectionItem>
                    ))}
                  </SectionItems>
                )}
              </Section>
            ))
            : placeholderArray.map(section => (
              <Section key={section.key}>
                <SectionTitle>
                  <Placeholder h="15px" w="200px" />
                </SectionTitle>

                {section.children && (
                  <SectionItems>
                    {section.children.map(item => (
                      <SectionItem key={item.key}>
                        <ItemTitle>
                          <Placeholder h="15px" w="125px" />
                        </ItemTitle>

                        {item.children && (
                          <Subitems>
                            {item.children.map(subitem => (
                              <Subitem key={subitem.key}>
                                <Placeholder h="15px" w="200px" />
                              </Subitem>
                            ))}
                          </Subitems>
                        )}
                      </SectionItem>
                    ))}
                  </SectionItems>
                )}
              </Section>
            ))}
        </Wrapper>
        {!(locale && copy && _.get(copy, 'sitemap')) ? (
          <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
        ) : (
          <BreadCrumbMenu
            currentPath={`https://www.shiseido-professional.com/${locale}/sitemap`}
            items={[
              {
                name: 'TOP',
                path: `/${locale}/`,
              },
              {
                name: copy.sitemap.toUpperCase(),
                path: null,
              },
            ]}
          />
        )}
      </React.Fragment>
    );
  }
}

Sitemap.defaultProps = {
  copy: undefined,
  sitemap: undefined,
};

Sitemap.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  sitemap: PropTypes.arrayOf(PropTypes.shape()),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySitemapPage,
  locale: state.locale,
  sitemap: state.siteOptions.sitemap,
});

export default connect(mapState)(Sitemap);



// WEBPACK FOOTER //
// ./src/pages/Sitemap/Sitemap.js